export enum State {
  default = 'default',
  valid = 'valid',
  invalid = 'invalid',
  disabled = 'disabled',
  warning = 'warning',
}
